import { create } from 'zustand';
import { tenantApi } from '../services/user/tenant.api';

interface TenantState {
  id: string | null;
  slug: string | null;
  name: string | null;
  slogan: string | null;
  logoUrl: string | null;
  isDefault: boolean;
  isLoaded: boolean;
  loadTenantInfo: () => Promise<void>;
}

export const useTenantStore = create<TenantState>((set) => ({
  id: null,
  slug: null,
  name: null,
  slogan: null,
  logoUrl: null,
  isDefault: false,
  isLoaded: false,

  loadTenantInfo: async () => {
    try {
      const info = await tenantApi.fetchTenantInfo();
      if ('isDefault' in info && info.isDefault) {
        set({
          isDefault: true,
          isLoaded: true,
          name: info.name ?? null,
          slogan: info.slogan ?? null,
          logoUrl: info.logoUrl ?? null,
        });
      } else {
        const tenant = info as Exclude<typeof info, { isDefault: true }>;
        set({
          id: tenant.id,
          slug: tenant.slug,
          name: tenant.name,
          slogan: tenant.slogan ?? null,
          logoUrl: tenant.logoUrl ?? null,
          isDefault: false,
          isLoaded: true,
        });
      }
    } catch {
      // 加载失败时视为默认租户，不阻塞应用
      set({ isDefault: true, isLoaded: true });
    }
  },
}));
